export default {
  LIST_FETCHED: 'TEMPLATES_DRAFTS_FETCHED',
  LIST_LOAD: 'TEMPLATES_DRAFTS_LOAD',
  ITEM_DETAIL: 'TEMPLATES_DRAFTS_DETAIL',
  BUTTON_LOAD: 'TEMPLATES_DRAFTS_BUTTON_LOAD',
};
